<template>
  <div class="w-100 h-100 m-0 d-flex flex-column align-items-center" style="padding: 32px 124px;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">データを送信しました</div>
    </div>

    <div style="margin-top:32px;">
      受け付け完了メールが届くまでしばらくお待ちください。
    </div>

    <div class="text-start" style="border-radius: 10px; background:#F5F7FA; font-size: 16px; width: 610px; padding:16px; margin-top:32px;">
      <p class="m-0">・確認メールはdesign@acry.co.jpからお送りします</p>
      <p class="m-0">・メールが届かない場合は、メールアドレスが間違っているか、迷惑メールフォルダに届いてしまっている可能性があります。</p>
      <p class="m-0">・ご入稿後は弊社にてデータのチェックを行い、お客様の承認を頂かない限り製作へは進みませんのでご安心ください。</p>
    </div>

    <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 56px; border-radius: 100px; font-size: 16px; margin-top:63px;" @click="clickReturnBtn">
      TOPに戻る
    </button>
  </div>
</template>

<script>
import { CenterViewState } from "@/js/Const.js";

export default {
  name: "CenterViewBehalfCreateComplate_Ap",
  props: {},
  data: function () {
    return {

    };
  },
  computed: {

  },
  async created() {
    this.$store.commit("hideRightMenu");

  },
  components: {
    
  },
  methods: {
    clickReturnBtn(){
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>


